import { createSelector } from 'reselect'
import carlineGroupsSelector from './carlineGroupsSelector'
import filtersSelector from '../filtersSelector'
import filterListSelector from '../filterListSelector'
import CarlineGroup from '../../../entities/CarlineGroup'
import carlineFiltersSelector from './carlineFiltersSelector'

const filteredCarlineGroupsSelector = createSelector(
    carlineGroupsSelector,
    carlineFiltersSelector,
    filtersSelector,
    filterListSelector,
    (carlineGroups, carlineFilters, appliedFilters, filterList): CarlineGroup[] => {
        const activeFilters = Object.entries(appliedFilters)
        
        if (activeFilters.every(([, values]) => values.length === 0)) {
            return carlineGroups
        }
        
        const carlineFilterMap = new Map(
            carlineFilters.map(filter => [filter.id, filter]),
        )

        return carlineGroups.map((carlineGroup) => {
            const { carlines } = carlineGroup

            const filteredCarlines = carlines.filter((carline) => {
                const carlineFilterData = carlineFilterMap.get(carline.id)
                
                if (!carlineFilterData?.attributesSet) {
                    return false
                }

                const modelAttributes = carlineFilterData.attributesSet.map(set => set.attributes) || []

                const hasMatchingModel = modelAttributes.some((modelAttribute) => {
                    return activeFilters.every(([filterKey, filterValues]) => {
                        if (filterValues.length === 0) {
                            return true
                        }
                        
                        const modelValue = modelAttribute[filterKey]
                        if (modelValue === undefined) {
                            return false
                        }
                        
                        const filterConfig = filterList.find(filter => filter.attribute === filterKey)

                        if (filterConfig?.type === 'max') {
                            const numericModelValue = parseFloat(modelValue)
                            const selectedMaxValue = filterValues[0]
                            const numericMaxValue = typeof selectedMaxValue === 'string' ? parseFloat(selectedMaxValue) : selectedMaxValue
                            
                            return !isNaN(numericModelValue) && 
                                   !isNaN(numericMaxValue) &&
                                   numericModelValue <= numericMaxValue
                        } else {
                            return filterValues.includes(modelValue)
                        }
                    })
                })

                return hasMatchingModel
            })

            return {
                ...carlineGroup,
                carlines: filteredCarlines,
            }
        })
    },
)

export default filteredCarlineGroupsSelector
